<template>
  <div class="el-file-upload">
    <el-upload
      ref="upload"
      :headers="headers"
      :action="action"
      :before-upload="beforeUpload"
      :on-success="onsuccess"
      :on-remove="onremove"
      :accept="accept"
      :file-list="fileList"
      :auto-upload="autoUpload">
      <el-button slot="trigger" size="small" type="primary" :loading="loading">选择文件</el-button>
      <span v-if="$slots.default" class="upload-tip">
        <slot />
      </span>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (val) {
          const url = new URL(val)
          this.fileList = [{url: val, name: url.searchParams.get('name')}]
        } else {
          this.fileList = []
        }
      }
    }
  },
  data () {
    return {
      action: process.env.VUE_APP_API_URL + 'sys/oss/upload',
      headers: {
        token: this.$cookie.get('token')
      },
      fileList: [],
      loading: false
    }
  },
  methods: {
    beforeUpload () {
      this.loading = true
    },
    onsuccess (res) {
      this.loading = false
      this.$emit('input', res.url)
      this.$emit('change', res.url)
    },
    onremove () {
      this.$emit('input', '')
    }
  }
}
</script>

<style lang="scss">
.el-file-upload {
  .upload-tip {
    font-size: 12px;
    color: #aaaaaa;
    margin-left: 6px;
  }
}
</style>